import React from "react";
import { Input } from "./ui/input";
import { QUALIFICATIONS } from "../lib/qualifications";

// Autocomplete input backed by a curated list; still allows any custom value.
export const QualificationInput = ({ value, onChange, id = "qualification", placeholder = "e.g. MBBS, BSc Nursing", className = "", required = false, listId = "qualification-options", ...props }) => (
  <>
    <Input
      id={id}
      list={listId}
      required={required}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      autoComplete="off"
      {...props}
    />
    <datalist id={listId}>
      {QUALIFICATIONS.map((q) => (
        <option key={q} value={q} />
      ))}
    </datalist>
  </>
);

export default QualificationInput;
